import { Component, computed, input } from '@angular/core';
import { Permission } from 'src/app/shared/constants/permissions';
import { Service } from '../../../models/service.model';

@Component({
  selector: 'app-service-top-header',
  templateUrl: './service-top-header.component.html',
  standalone: false,
})
export class ServiceTopHeaderComponent {
  readonly services = input<Service[]>();

  readonly activeServices = input<Service[]>();

  readonly totalLocations = input<number | null>(null);

  readonly isLoading = input<boolean>(false);

  readonly Permission = Permission;

  readonly totalServices = computed(() => (this.activeServices() ?? []).length);

  readonly pendingServices = computed(
    () =>
      (this.services() ?? []).filter((s) =>
        ['New', 'Pending'].includes(s.Status__c),
      ).length,
  );

  readonly inServiceServices = computed(
    () =>
      (this.services() ?? []).filter((s) => s.Status__c === 'In Service')
        .length,
  );

  readonly hasBandwidthData = computed(() =>
    (this.services() ?? []).some((s) => !!s.Bandwidth_Downstream__c),
  );

  readonly serviceTypeObject = computed(() => {
    const recordTypeCounts: { [recordTypeName: string]: number } = {};

    (this.services() ?? [])
      .filter(
        (s) =>
          !['Canceled', 'Disconnected', 'New', 'Pending'].includes(s.Status__c),
      )
      .forEach((service) => {
        const recordTypeName = service.RecordType.Name;
        recordTypeCounts[recordTypeName] =
          (recordTypeCounts[recordTypeName] ?? 0) + 1;
      });

    return recordTypeCounts;
  });
}
